import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./stage5.css";
import endHouse from "./images/end.png";
import astroImg from "./images/astro.png"; // or astro.jpg
import astroAltImg from "./images/astro2.png"; // or astro.jpg
import astro3Img from "./images/astro3.png";
import astro4Img from "./images/astro4.png";



import Swal from "sweetalert2";
import { fetchReport, updateReport } from "../../scoreservice";

// const SEED = 949960367;
const SEED = 8369478271;
// const SEED = Math.floor(Math.random() * 1e9);
console.log("thia is seed--", SEED);

const SAVED_MAZE = [[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1], [1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0], [1, 0, 1, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0], [1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0], [1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0], [1, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0], [1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0], [1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0], [1, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1], [1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0], [1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0], [1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0], [1, 1, 1, 0, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0], [1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0], [1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 0], [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0], [1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0], [1, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0], [1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 0, 1, 1, 1, 1, 1], [1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0], [1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0], [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0], [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]];
/* ---------------- CONFIG ---------------- */

const getMazeConfig = () => {
    const isMobile = window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
    const isLandscape = window.innerWidth > window.innerHeight;

    // Mobile landscape
    if (isMobile && isLandscape) {
        // For mobile landscape, use fewer rows but more columns
        if (window.innerWidth < 600) {
            return { ROWS: 23, COLS: 26, CELL: 12 };
        }
        return { ROWS: 23, COLS: 26, CELL: 12 };
    }

    // Mobile portrait (existing)
    if (isMobile) {
        return { ROWS: 23, COLS: 26, CELL: window.innerWidth < 400 ? 11 : 12 };
    }

    // Tablet
    if (isTablet) {
        return { ROWS: 23, COLS: 26, CELL: 10 };
    }

    // Desktop
    return { ROWS: 23, COLS: 26, CELL: 18 };
};


const timeToSeconds = (timeStr = "00:00") => {
    const [m = 0, s = 0] = timeStr.split(":").map(Number);
    return m * 60 + s;
};
export default function Stage5({ updateHeader }) {
    useEffect(() => {
        updateHeader({ backButtonRedirect: "/stage5" });


    }, []); // run once on mount
    const STAGE = 5;
    const navigate = useNavigate();
    const [userData, setUserData] = useState({});
    const [initialTime, setInitialTime] = useState("00:00");
    const [ready, setReady] = useState(false);
    const [totalScore, setTotalScore] = useState(0);
    const [completed, setCompleted] = useState(false);
    const [SESSION_KEY, setSessionKey] = useState(null);
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [config, setConfig] = useState(getMazeConfig());
    const [maze, setMaze] = useState([]);
    const [player, setPlayer] = useState({ r: 1, c: 1 });
    const [end, setEnd] = useState(null);
    const [isMobileDevice, setIsMobileDevice] = useState(false);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [showPlayerModal, setShowPlayerModal] = useState(true);


    /* ---------------- CHECK MOBILE DEVICE ---------------- */

    useEffect(() => {
        const checkMobile = () => {
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            setIsMobileDevice(isMobile || hasTouch || window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    /* ---------------- RESIZE & ORIENTATION ---------------- */

    useEffect(() => {
        const handleResizeAndOrientation = () => {
            setConfig(getMazeConfig());
            // Re-generate maze with new config
            const m = generateMaze(getMazeConfig().ROWS, getMazeConfig().COLS, SEED);
            setMaze(m);
            setEnd(findFarthestPoint(m, 1, 1));
            setPlayer({ r: 1, c: 1 });
        };

        window.addEventListener("resize", handleResizeAndOrientation);
        window.addEventListener("orientationchange", handleResizeAndOrientation);

        return () => {
            window.removeEventListener("resize", handleResizeAndOrientation);
            window.removeEventListener("orientationchange", handleResizeAndOrientation);
        };
    }, []);

    /* ---------------- MAZE INIT ---------------- */

    // useEffect(() => {
    //   const m = generateMaze(config.ROWS, config.COLS, SEED);

    //   createStartBranches(m, 1, 1, 3);
    //   addDeadEnds(m, 3, 4);
    //   addLoops(m, 0.05);

    //   // 🔥 THIS IS WHAT YOU NEED TO SAVE THE PATTERN
    //   console.log("FINAL_MAZE_MATRIX ↓↓↓");
    //   console.log(JSON.stringify(m));

    //   setMaze(m);
    //   setEnd(findFarthestPoint(m, 1, 1));
    //   setPlayer({ r: 1, c: 1 });
    //   setCompleted(false);
    // }, [config]);

    useEffect(() => {
        const m = SAVED_MAZE.map(row => row.slice());

        setMaze(m);
        setEnd(findFarthestPoint(m, 1, 1));
        setPlayer({ r: 1, c: 1 });
        setCompleted(false);
    }, [config]);

    /* ---------------- USER DATA & STAGE CHECK ---------------- */

    useEffect(() => {
        const storedUserData = sessionStorage.getItem("userData");
        if (storedUserData) {
            setUserData(JSON.parse(storedUserData));
        }
    }, []);

    useEffect(() => {
        const checkStageCompletion = async () => {
            try {
                if (!userData?.userId || !userData?.sessionId) return;

                const res = await fetchReport({
                    userId: userData.userId,
                    sessionId: userData.sessionId,
                    organizationId: userData.organizationId,
                    stage: STAGE,
                });

                // Set up session timer
                if (userData?.sessionId && userData?.userId) {
                    const key = `stage_timer_${userData.sessionId}_${userData.userId}`;
                    setSessionKey(key);

                    if (!sessionStorage.getItem(key)) {
                        sessionStorage.setItem(
                            key,
                            JSON.stringify({
                                userId: userData.userId,
                                sessionId: userData.sessionId,
                                startTime: Date.now(),
                            })
                        );
                    }
                }

                console.log("data5", res);
                if (Number(res?.points) !== 0) {
                    navigate("/stage6", { replace: true });
                }
            } catch (err) {
                console.error("Stage check failed", err);
            }
        };

        if (userData?.sessionId) {
            checkStageCompletion();
        }
    }, [userData, navigate]);

    /* ---------------- LOAD STAGE DATA ---------------- */

    useEffect(() => {
        const loadStageData = async () => {
            if (!userData?.userId) return;

            try {
                const res = await fetchReport({
                    userId: userData.userId,
                    sessionId: userData.sessionId,
                    organizationId: userData.organizationId,
                    stage: STAGE,
                });

                if (res.status === "success") {
                    setTotalScore(res.total_score || 0);
                    setInitialTime(res.time || "00:00");

                    if ((res.points || 0) > 0) {
                        navigate("/stage6");
                        return;
                    }
                } else {
                    setInitialTime("00:00");
                }
            } catch (err) {
                console.error("Fetch stage5 failed", err);
                setInitialTime("00:00");
            } finally {
                setReady(true);
            }
        };

        loadStageData();
    }, [userData, navigate]);

    /* ---------------- TIMER ---------------- */

    // useEffect(() => {
    //   if (!SESSION_KEY) return;

    //   const sessionData = sessionStorage.getItem(SESSION_KEY);
    //   if (!sessionData) return;

    //   const { startTime } = JSON.parse(sessionData);

    //   const interval = setInterval(() => {
    //     const elapsedMs = Date.now() - startTime;
    //     const totalSeconds = Math.floor(elapsedMs / 1000);

    //     const mins = Math.floor(totalSeconds / 60);
    //     const secs = totalSeconds % 60;

    //     setMinutes(mins);
    //     setSeconds(secs);
    //   }, 1000);

    //   return () => clearInterval(interval);
    // }, [SESSION_KEY]);


    useEffect(() => {
        if (!initialTime) return;

        const baseSeconds = timeToSeconds(initialTime);
        const startTime = Date.now();

        const interval = setInterval(() => {
            const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
            const totalSeconds = baseSeconds + elapsedSeconds;

            setMinutes(Math.floor(totalSeconds / 60));
            setSeconds(totalSeconds % 60);
        }, 1000);

        return () => clearInterval(interval);
    }, [initialTime]);
    const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

    /* ---------------- STAGE COMPLETE ---------------- */

    const handleCompletion = async () => {
        if (completed) return;

        setCompleted(true);
        setTotalScore((p) => p + 1);
        console.log("total score5---", totalScore);


        try {
            await updateReport({
                sessionId: userData.sessionId,
                userId: userData.userId,
                organizationId: userData.organizationId,
                reportId: userData.reportId,
                stage: STAGE,
                score: Number(totalScore) + 1,
                time: formattedTime,
                roles: userData.roles,
                token: userData.token || ""
            });

            Swal.fire({
                imageUrl: "/img/success.gif",
                showConfirmButton: false,
                timer: 3000,
                background: "transparent",
            });

            setTimeout(() => {
                navigate("/stage6");
            }, 3000);
        } catch (err) {
            console.error("Stage5 submit error", err);
        }
    };

    const handleSkip = async () => {
        if (completed) return;

        setCompleted(true);

        try {
            await updateReport({
                sessionId: userData.sessionId,
                userId: userData.userId,
                organizationId: userData.organizationId,
                reportId: userData.reportId,
                stage: STAGE,
                score: Number(totalScore) + 0, // 👈 skip = 0 points
                time: formattedTime,
                roles: userData.roles,
                token: userData.token || ""
            });

            navigate("/stage6");
        } catch (err) {
            console.error("Stage5 skip error", err);
        }
    };


    /* ---------------- MOVEMENT FUNCTION ---------------- */

    const movePlayer = useCallback((direction) => {
        // if (completed || !end || !maze.length) return;
        if (completed || !end || !maze.length || !selectedPlayer || showPlayerModal) return;



        let { r, c } = player;

        switch (direction) {
            case 'up': r--; break;
            case 'down': r++; break;
            case 'left': c--; break;
            case 'right': c++; break;
            default: return;
        }

        if (maze[r]?.[c] === 0) {
            setPlayer({ r, c });
            if (r === end.r && c === end.c) {
                handleCompletion();
            }
        }
    }, [player, maze, end, completed, selectedPlayer, handleCompletion]);

    /* ---------------- KEYBOARD CONTROLS ---------------- */

    useEffect(() => {
        const move = (e) => {
            // if (completed || !end) return;
            if (completed || !end || !selectedPlayer || showPlayerModal) return;



            let { r, c } = player;
            if (e.key === "ArrowUp" || e.key === "w" || e.key === "W") r--;
            if (e.key === "ArrowDown" || e.key === "s" || e.key === "S") r++;
            if (e.key === "ArrowLeft" || e.key === "a" || e.key === "A") c--;
            if (e.key === "ArrowRight" || e.key === "d" || e.key === "D") c++;

            if (maze[r]?.[c] === 0) {
                setPlayer({ r, c });
                if (r === end.r && c === end.c) {
                    handleCompletion();
                }
            }
        };

        window.addEventListener("keydown", move);
        return () => window.removeEventListener("keydown", move);
    }, [player, maze, end, completed, selectedPlayer]);


    /* ---------------- MOBILE CONTROL HANDLERS ---------------- */

    const handleUp = () => movePlayer('up');
    const handleDown = () => movePlayer('down');
    const handleLeft = () => movePlayer('left');
    const handleRight = () => movePlayer('right');

    /* ---------------- RENDER ---------------- */
    const handlePlayerSelect = (img) => {
        setSelectedPlayer(img);
        setShowPlayerModal(false);
    };



    return (
        <div className="stage5-bg">
            {/* PLAYER SELECTION MODAL */}
            {showPlayerModal && (
                <div className="player-modal-overlay">
                    <div className="player-modal">
                        <h3 className="avt-title">Choose an avatar to disguise yourself and sneak into the warehouse to retrieve the currency plates.</h3>

                        <div className="player-options">
                            <img
                                src={astroImg}
                                alt="Player 1"
                                onClick={() => handlePlayerSelect(astroImg)}
                            />
                            <img
                                src={astroAltImg}
                                alt="Player 2"
                                onClick={() => handlePlayerSelect(astroAltImg)}
                            />
                            <img
                                src={astro3Img}
                                alt="Player 3"
                                onClick={() => handlePlayerSelect(astro3Img)}
                            />
                            <img
                                src={astro4Img}
                                alt="Player 4"
                                onClick={() => handlePlayerSelect(astro4Img)}
                            />
                        </div>

                    </div>
                </div>
            )}


            <div className="screen">
                <h4 className="gameHead-5">
                    Stealth Mission: Explore the surroundings and retrieve the mint plates. Use arrow keys to move through the maze.
                </h4>
                <div className="top-bar-5">
                    <div className="top-left-5">
                        <div className="timer-back-5">Time: {formattedTime}</div>
                    </div>

                    <div className="top-right-5">
                        <div className="skip-btn-5" onClick={handleSkip}>Skip</div>
                        <div className="score-5">Points: {totalScore}</div>
                    </div>
                </div>




                <div className="maze-wrapper">
                    <div
                        className="maze"
                        style={{ gridTemplateColumns: `repeat(${config.COLS}, ${config.CELL}px)` }}
                    >
                        {maze.map((row, r) =>
                            row.map((cell, c) => (
                                <div
                                    key={`${r}-${c}`}
                                    className={`cell ${cell ? "wall" : "path"} ${end && r === end.r && c === end.c ? "end" : ""
                                        }`}
                                    style={{ width: config.CELL, height: config.CELL }}
                                />
                            ))
                        )}



                        {selectedPlayer && (
                            <div
                                className="player"
                                style={{
                                    top: player.r * config.CELL,
                                    left: player.c * config.CELL,
                                    width: config.CELL * 0.5,
                                    height: config.CELL * 0.5,
                                    backgroundImage: `url(${selectedPlayer})`,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center"
                                }}
                            />
                        )}


                    </div>
                </div>

                {/* Mobile Controls */}
                {isMobileDevice && (
                    <div className="mobile-controls">

                        <div className="control-row">
                            <div className="control-spacer"></div>
                            <button className="control-btn" onClick={handleUp} aria-label="Move Up">
                                ↑
                            </button>
                            <div className="control-spacer"></div>
                        </div>
                        <div className="control-row">
                            <button className="control-btn" onClick={handleLeft} aria-label="Move Left">
                                ←
                            </button>
                            <div className="control-spacer"></div>
                            <button className="control-btn" onClick={handleRight} aria-label="Move Right">
                                →
                            </button>
                        </div>
                        <div className="control-row">
                            <div className="control-spacer"></div>
                            <button className="control-btn" onClick={handleDown} aria-label="Move Down">
                                ↓
                            </button>
                            <div className="control-spacer"></div>
                        </div>
                    </div>
                )}

                <img src={endHouse} alt="end" className="end-house" />
                {selectedPlayer && (
                    <img
                        src={selectedPlayer}
                        alt="start-player"
                        className="start-player"

                    />
                )}

            </div>
        </div>
    );
}

/* ---------------- HELPER FUNCTIONS ---------------- */

function findFarthestPoint(maze, startR, startC) {
    const visited = maze.map((r) => r.map(() => false));
    const q = [{ r: startR, c: startC, d: 0 }];
    visited[startR][startC] = true;
    let farthest = q[0];

    while (q.length) {
        const cur = q.shift();
        if (cur.d > farthest.d) farthest = cur;

        for (const [dr, dc] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
            const nr = cur.r + dr, nc = cur.c + dc;
            if (maze[nr]?.[nc] === 0 && !visited[nr][nc]) {
                visited[nr][nc] = true;
                q.push({ r: nr, c: nc, d: cur.d + 1 });
            }
        }
    }
    return { r: farthest.r, c: farthest.c };
}
function addLoops(maze, chance = 0.08) {
    for (let r = 1; r < maze.length - 1; r++) {
        for (let c = 1; c < maze[0].length - 1; c++) {
            if (maze[r][c] === 1 && Math.random() < chance) {
                const openNeighbors =
                    (maze[r - 1][c] === 0) +
                    (maze[r + 1][c] === 0) +
                    (maze[r][c - 1] === 0) +
                    (maze[r][c + 1] === 0);

                // only break walls that connect paths
                if (openNeighbors >= 2) {
                    maze[r][c] = 0;
                }
            }
        }
    }
}

function openStartArea(maze, startR, startC, branches = 3) {
    const dirs = [
        [1, 0],
        [-1, 0],
        [0, 1],
        [0, -1],
    ];

    let opened = 0;

    for (const [dr, dc] of dirs.sort(() => Math.random() - 0.5)) {
        if (opened >= branches) break;

        const r1 = startR + dr;
        const c1 = startC + dc;
        const r2 = startR + dr * 2;
        const c2 = startC + dc * 2;

        if (
            maze[r2]?.[c2] === 0 &&   // connect to an existing path
            maze[r1]?.[c1] === 1
        ) {
            maze[r1][c1] = 0;
            opened++;
        }
    }
}
function createStartBranches(maze, startR, startC, branches = 3) {
    const dirs = [
        [0, 2],
        [2, 0],
        [0, -2],
        [-2, 0],
    ].sort(() => Math.random() - 0.5);

    let opened = 0;

    for (const [dr, dc] of dirs) {
        if (opened >= branches) break;

        const nr = startR + dr;
        const nc = startC + dc;
        const wr = startR + dr / 2;
        const wc = startC + dc / 2;

        // Only open if it connects to existing maze
        if (maze[nr]?.[nc] === 0 && maze[wr]?.[wc] === 1) {
            maze[wr][wc] = 0;
            opened++;
        }
    }
}

function addDeadEnds(maze, count = 3, maxLength = 4) {
    const candidates = [];

    // find corridor cells (paths with exactly 2 neighbors)
    for (let r = 1; r < maze.length - 1; r++) {
        for (let c = 1; c < maze[0].length - 1; c++) {
            if (maze[r][c] !== 0) continue;

            const neighbors =
                (maze[r - 1][c] === 0) +
                (maze[r + 1][c] === 0) +
                (maze[r][c - 1] === 0) +
                (maze[r][c + 1] === 0);

            if (neighbors === 2) {
                candidates.push({ r, c });
            }
        }
    }

    // shuffle candidates
    candidates.sort(() => Math.random() - 0.5);

    let added = 0;

    for (const { r, c } of candidates) {
        if (added >= count) break;

        const dirs = [
            [1, 0],
            [-1, 0],
            [0, 1],
            [0, -1],
        ].sort(() => Math.random() - 0.5);

        for (const [dr, dc] of dirs) {
            let cr = r;
            let cc = c;
            let carved = 0;

            while (carved < maxLength) {
                const nr = cr + dr;
                const nc = cc + dc;
                const wr = cr + dr / 2;
                const wc = cc + dc / 2;

                if (
                    maze[nr]?.[nc] !== 1 ||
                    maze[wr]?.[wc] !== 1
                ) break;

                maze[wr][wc] = 0;
                maze[nr][nc] = 0;

                cr = nr;
                cc = nc;
                carved++;
            }

            if (carved > 0) {
                added++;
                break;
            }
        }
    }
}
function generateMaze(rows, cols, seed) {
    const rand = seededRandom(seed);
    const maze = Array.from({ length: rows }, () => Array(cols).fill(1));

    function carve(r, c) {
        maze[r][c] = 0;
        [[0, 2], [0, -2], [2, 0], [-2, 0]]
            .sort(() => rand() - 0.5)
            .forEach(([dr, dc]) => {
                const nr = r + dr, nc = c + dc;
                if (maze[nr]?.[nc] === 1) {
                    maze[r + dr / 2][c + dc / 2] = 0;
                    carve(nr, nc);
                }
            });
    }

    carve(1, 1);
    return maze;
}

function seededRandom(seed) {
    return () => (seed = (seed * 9301 + 49297) % 233280) / 233280;
}